<template>
  <AppDialog :is-open="isDialogOpened"
             @cancel="closeDialog"
             @ok="onOk"
  >
    <template #title>
      <span v-t="{
                path: 'project.signed-documents.dialogs.DeleteSignedDocument.title',
                plural: documents.length,
              }"
      />
    </template>
    <template #body>
      <p v-t="{
                path: 'project.signed-documents.dialogs.DeleteSignedDocument.text1',
                plural: documents.length,
              }"
      />
      <p v-t="{
                path: 'project.signed-documents.dialogs.DeleteSignedDocument.text2',
                plural: documents.length,
              }"
      />
    </template>
  </AppDialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { GET_SIGNED_DOCUMENTS } from '@/store/modules/signed-documents/action_types'

export default {
  name: 'DeleteSignedDocument',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
  emits: ['delete-success'],
  computed: {
    ...mapGetters('room', ['roomMnemo']),
  },
  methods: {
    ...mapActions('signedDocuments', ['deleteOriginal', 'getMySignatures', GET_SIGNED_DOCUMENTS]),
    async onOk () {
      try {
        await this.deleteOriginal({ mnemo: this.roomMnemo, data: { envelopesIds: this.documents.map(o => o.id) } })
        toast.success(this.$t('project.signed-documents.dialogs.DeleteSignedDocument.deleteOriginalSuccess', this.documents.length))
        this.GET_SIGNED_DOCUMENTS({ mnemo: this.roomMnemo, params: {
            rightsDetails: true,
            fileDetails: true,
            signatureDetails: true,
          },
        })
        this.$emit('delete-success')
      } catch (e) {
        toast.error(this.$t('project.signed-documents.dialogs.DeleteSignedDocument.deleteOriginalError', this.documents.length))
      } finally {
        this.closeDialog()
      }
    },
  },
}
</script>
